module.exports = __webpack_public_path__ + "img/predicciones_max_dm.f7e76591.png";